import { EventsHeroCarousel } from "@jesus-central-church/ui";
import type { SbEventHero } from "@storyblok/types/287435740670216/storyblok-components";
import { getAllUpcomingEvents } from "../../lib/events";

export async function EventHeroComponent({
  blok,
  pageData,
}: {
  blok: SbEventHero;
  pageData: { locale: string };
}) {
  const { locale } = pageData;
  const events = await getAllUpcomingEvents(locale);

  return (
    <EventsHeroCarousel
      events={events}
      emptyTitle={blok.emptyHeading}
      emptyDescription={blok.emptyDescription}
      emptyButtonText={blok.contactUsText}
      registrationText={blok.registrationButtonText}
      seeDetailsText={blok.seeDetailButtonText}
    />
  );
}
